import { NovaPluginIds } from "panels/controls/PluginAccessPanel/constants"
import { usePluginSampleData } from "../usePluginSampleData"
import { TryAddOnItem } from "./TryAddOnItem"

export const TryAddOnItemHotspots = () => {
    const plugin = usePluginSampleData(NovaPluginIds.IR)
    return <TryAddOnItem plugin={plugin} />
}
